import { getCookie } from "../utilities/helper";

const BAGGAGE_KEY = 'login.session_id';
const KFONE_LOGIN_SESSION_ID_COOKIE = '__kfone_login_session_id';

//generate class KfSessionBaggageInterceptor implements HttpInterceptor
export const KfSessionBaggageInterceptor = (req: any): any => {
        console.log("KfSessionBaggageInterceptor", req);
        const isProtected = req.headers.has('Authorization') || req.headers.has('ps-session-id');
        if (!isProtected) {
            return req;
        }

        const sessionId = getCookie(KFONE_LOGIN_SESSION_ID_COOKIE);
        console.log("sessionId", sessionId);
        if (!sessionId) {
            return req;
        }

        const member = `${BAGGAGE_KEY}=${sessionId}`;
        const existing = req.headers.get('baggage');
        const baggage = existing ? `${existing},${member}` : member;

        req.headers.set('baggage', baggage);
        return req;
}